import React from 'react';
import PropTypes from 'prop-types';
import { StatusIndicator } from '@getro/rombo';
import { Box, Flex } from 'rebass/styled-components';

export const visibilityConfig = {
  visible_forced: { status: 'Visible (manually)', statusColor: 'success' },
  hidden_forced: { status: 'Hidden (manually)', statusColor: 'neutral.300' },
  hidden: { status: 'Hidden', statusColor: 'neutral.300' },
  not_visible: { status: 'Not visible', statusColor: 'neutral.300' },
};

const JobVisibility = ({ visibility, onShowJobRulesClick }) => {
  switch (visibility) {
    case 'visible_forced':
      return (
        <StatusIndicator
          status={
            <Box
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {visibilityConfig[visibility].status}
            </Box>
          }
          statusColor={visibilityConfig[visibility].statusColor}
        />
      );
    case 'hidden_forced':
      return (
        <StatusIndicator
          status={
            <Box
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {visibilityConfig[visibility].status}
            </Box>
          }
          statusColor={visibilityConfig[visibility].statusColor}
        />
      );
    case 'hidden':
      return (
        <StatusIndicator
          status={
            <Flex
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              Hidden
              <Box
                as="span"
                onClick={onShowJobRulesClick}
                variant="link"
                sx={{
                  p: 0,
                  color: 'text.main',
                  fontWeight: 'body',
                  textAlign: 'left',
                  textDecoration: 'underline',
                  backgroundColor: 'transparent',
                  height: '24px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  cursor: 'pointer',
                }}
              >
                (job rules)
              </Box>
            </Flex>
          }
          statusColor={visibilityConfig[visibility].statusColor}
        />
      );
    case 'not_visible':
      return (
        <StatusIndicator
          status={visibilityConfig[visibility].status}
          statusColor={visibilityConfig[visibility].statusColor}
        />
      );
    default:
      return <StatusIndicator status="Visible" statusColor="success" />;
  }
};

JobVisibility.propTypes = {
  visibility: PropTypes.string.isRequired,
  onShowJobRulesClick: PropTypes.func.isRequired,
};

export default JobVisibility;
